import {Pinia} from 'pinia'
import {RouteLocationNormalized, RouteLocationRaw} from 'vue-router'
import {useResourceItemStore} from '@toolify/client/src/stores/ResourceItemStore/useResourceItemStore'
import {useSpaceStore} from '@toolify/client/src/stores/SpaceStore/useSpaceStore'
import {getTargetRouteForSpace, getFirstResourceRouteAnywhere} from '@toolify/client/src/modules/resources/utils/getLastVisitedResourceRouteForSpace'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'

export function getRedirectToLastVisitedResourceForWorkspaceHome(
  to: RouteLocationNormalized,
  pinia?: Pinia,
): RouteLocationRaw | undefined {
  const workspaceName = to.params.workspaceName as string
  if(!workspaceName) {
    return undefined
  }
  const spaceStore = pinia ? useSpaceStore(pinia) : useSpaceStore()
  const resourceItemStore = pinia ? useResourceItemStore(pinia) : useResourceItemStore()
  const currentSpaceId = spaceStore.currentSpace?.id ?? spaceStore.currentSpaceId
  const resourceItems = resourceItemStore.resourceItems
  if(!resourceItems?.length) {
    return undefined
  }
  if(currentSpaceId) {
    const targetRoute = getTargetRouteForSpace({
      workspaceName,
      spaceId: currentSpaceId,
      resourceItems,
    })
    const isWorkspaceHomeRoute = typeof targetRoute === 'object'
      && 'name' in targetRoute
      && targetRoute.name === RouteName.WorkspaceHome
    if(!isWorkspaceHomeRoute) {
      return targetRoute
    }
    // Empty current space — stay on workspace home instead of jumping to a resource in another space.
    return undefined
  }

  return getFirstResourceRouteAnywhere(workspaceName, resourceItems) ?? undefined
}
